<title mat-dialog-title>Editing Layer {{ layer.layers.name }}</title>
<mat-dialog-content>
  <sn-form [form]="form" [fields]="formFields" [model]="formModel"></sn-form>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button color="danger" mat-dialog-close type="button">Cancel</button>
  <button mat-button color="success" [disabled]="form.invalid" (click)="submit()">Submit</button>
</mat-dialog-actions>
